import React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

const MedalBadge = ({ size }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 91 91">
      <G
        id="badges"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <G id="1-copy-48" transform="translate(-257.000000, -474.000000)">
          <G id="Group-3" transform="translate(259.000000, 476.000000)">
            <Circle
              id="Oval"
              stroke="#FFE66D"
              strokeWidth="4"
              fillOpacity="0.8"
              fill="#4250FB"
              cx="43.5"
              cy="43.5"
              r="43.5"
            />
            <G
              id="medal"
              transform="translate(20.000000, 21.000000)"
              fillRule="nonzero"
            >
              <Path
                d="M23.8489209,25.4028777 L23.7204208,18.1585733 L19.0951333,13.4028777 L14.8489209,17.6766283 L16.5097839,20.7440753 L23.088629,25.1705499 C23.3149318,25.3232739 23.5790708,25.4028777 23.8489209,25.4028777 L23.8489209,25.4028777 Z"
                id="Path"
                fill="#EA0016"
              />
              <Path
                d="M14.7241674,2.4028777 L9.93350897,14.760111 C9.71690178,15.3202645 9.92692409,15.9514847 10.4419294,16.2836882 L16.8295896,20.4028777 L19.3398072,13.5707487 L19.8489209,8.3624278 L14.7241674,2.4028777 Z"
                id="Path"
                fill="#FF193D"
              />
              <Path
                d="M37.7780121,14.760111 L32.8743792,2.4028777 L23.4254053,2.4028777 L21.8489209,5.23549097 L26.8309523,17.5307084 L30.7193065,20.4028777 L37.2576019,16.2836882 C37.719834,15.9933873 37.9841186,15.2820494 37.7780121,14.760111 Z"
                id="Path"
                fill="#EA0016"
              />
              <Path
                d="M24.4430052,2.4028777 L14.8489209,2.4028777 L24.4430052,25.4028777 C24.7153107,25.4028777 24.9818531,25.3265908 25.210215,25.1802303 L31.8489209,20.9381921 L24.4430052,2.4028777 Z"
                id="Path"
                fill="#FF5B5B"
              />
              <Path
                d="M30.8489209,20.9381921 L23.8489209,2.4028777 L23.8489209,25.4028777 C24.1063013,25.4028777 24.3582346,25.3265908 24.5740801,25.1802303 L30.8489209,20.9381921 Z"
                id="Path"
                fill="#FF193D"
              />
              <Path
                d="M35.8489209,1.9028777 C35.8489209,2.7427215 35.2624626,3.4028777 34.5155875,3.4028777 L13.1822542,3.4028777 C12.4353792,3.4028777 11.8489209,2.7427215 11.8489209,1.9028777 C11.8489209,1.0626433 12.4353792,0.402877698 13.1822542,0.402877698 L34.5155875,0.402877698 C35.2624626,0.402877698 35.8489209,1.0626433 35.8489209,1.9028777 Z"
                id="Path"
                fill="#FFDA2D"
              />
              <Path
                d="M35.8489209,1.9028777 C35.8489209,2.7427215 35.2624626,3.4028777 34.5155875,3.4028777 L23.8489209,3.4028777 L23.8489209,0.402877698 L34.5155875,0.402877698 C35.2624626,0.402877698 35.8489209,1.0626433 35.8489209,1.9028777 Z"
                id="Path"
                fill="#FDBF00"
              />
              <Path
                d="M17.8489209,38.4028777 L12.3943754,38.4028777 C9.38194641,38.4028777 6.84892086,36.0150305 6.84892086,33.0695444 L6.84892086,30.4028777 L17.8489209,30.4028777 L17.8489209,38.4028777 Z"
                id="Path"
                fill="#FDBF00"
              />
              <Path
                d="M19.8489209,33.4028777 L9.15278827,33.4028777 C6.22357554,33.4028777 3.84892086,31.0150305 3.84892086,28.0695444 L3.84892086,25.4028777 L19.8489209,25.4028777 L19.8489209,33.4028777 Z"
                id="Path"
                fill="#FFDA2D"
              />
              <Path
                d="M19.8489209,28.4028777 L4.90105356,28.4028777 C2.66323519,28.4028777 0.848920863,26.3880339 0.848920863,23.9028777 C0.848920863,23.0743621 1.45357506,22.4028777 2.19963176,22.4028777 L18.49821,22.4028777 L19.8489209,28.4028777 Z"
                id="Path"
                fill="#FDBF00"
              />
              <Path
                d="M30.8489209,38.4028777 L36.3034663,38.4028777 C39.3158953,38.4028777 41.8489209,36.0150305 41.8489209,33.0695444 L41.8489209,30.4028777 L30.8489209,30.4028777 L30.8489209,38.4028777 Z"
                id="Path"
                fill="#FF9100"
              />
              <Path
                d="M27.8489209,33.4028777 L38.5450535,33.4028777 C41.4742662,33.4028777 43.8489209,31.0150305 43.8489209,28.0695444 L43.8489209,25.4028777 L27.8489209,25.4028777 L27.8489209,33.4028777 Z"
                id="Path"
                fill="#FDBF00"
              />
              <Path
                d="M27.8489209,28.4028777 L42.7967882,28.4028777 C45.0346065,28.4028777 46.8489209,26.3880339 46.8489209,23.9028777 C46.8489209,23.0743621 46.2442667,22.4028777 45.49821,22.4028777 L29.1996318,22.4028777 L27.8489209,28.4028777 Z"
                id="Path"
                fill="#FF9100"
              />
              <Path
                d="M36.6631657,32.7153777 L31.1109108,23.0903777 C30.8632372,22.6778777 30.423724,22.4028777 29.9287348,22.4028777 L18.768749,22.4028777 C18.2741177,22.4028777 17.8342466,22.6778777 17.5869309,23.0903777 L12.034676,32.7153777 C11.7870025,33.1278777 11.7870025,33.6778777 12.034676,34.0903777 L17.5869309,43.7153777 C17.8342466,44.1278777 18.2741177,44.4028777 18.768749,44.4028777 L29.9290927,44.4028777 C30.423724,44.4028777 30.8635951,44.1278777 31.1109108,43.7153777 L36.6631657,34.0903777 C36.9108392,33.6778777 36.9108392,33.1278777 36.6631657,32.7153777 Z"
                id="Path"
                fill="#FFF261"
              />
              <Path
                d="M35.6705959,34.0903777 L30.3404312,43.7153777 C30.1026646,44.1278777 29.6807319,44.4028777 29.2055422,44.4028777 L23.8489209,44.4028777 L23.8489209,22.4028777 L29.2058858,22.4028777 C29.6807319,22.4028777 30.1030082,22.6778777 30.3404312,23.0903777 L35.6705959,32.7153777 C35.9083625,33.1278777 35.9083625,33.6778777 35.6705959,34.0903777 L35.6705959,34.0903777 Z"
                id="Path"
                fill="#FFDA2D"
              />
              <Path
                d="M29.6677071,32.2153777 L27.3618579,28.0903777 C27.1202396,27.6778777 26.6645865,27.4028777 26.1816989,27.4028777 L21.515881,27.4028777 C21.0333425,27.4028777 20.5773403,27.6778777 20.3360711,28.0903777 L18.0298728,32.2153777 C17.7886036,32.6278777 17.7886036,33.1778777 18.0298728,33.5903777 L20.3360711,37.7153777 C20.5773403,38.1278777 21.0333425,38.4028777 21.515881,38.4028777 L26.1816989,38.4028777 C26.6645865,38.4028777 27.1202396,38.1278777 27.3618579,37.7153777 L29.6677071,33.5903777 C29.9093255,33.1778777 29.9093255,32.6278777 29.6677071,32.2153777 Z"
                id="Path"
                fill="#FFDA2D"
              />
              <Path
                d="M29.6676634,33.5903777 L27.3618143,37.7153777 C27.1201959,38.1278777 26.6645428,38.4028777 26.1816553,38.4028777 L23.8489209,38.4028777 L23.8489209,27.4028777 L26.1820044,27.4028777 C26.6645428,27.4028777 27.1201959,27.6778777 27.3618143,28.0903777 L29.6680126,32.2153777 C29.9092818,32.6278777 29.9092818,33.1778777 29.6676634,33.5903777 Z"
                id="Path"
                fill="#FDBF00"
              />
            </G>
          </G>
        </G>
      </G>
    </Svg>
  );
};

MedalBadge.defaultProps = {
  size: 91,
};

export default MedalBadge;
